import { COMMA, ENTER } from "@angular/cdk/keycodes";
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatAutocompleteSelectedEvent } from "@angular/material/autocomplete";
import { MatChipInputEvent } from "@angular/material/chips";
import { select, Store } from "@ngrx/store";
import {
  WarehouseService,
  ApiVisa
} from "blg-akaun-ts-lib";

import { AppConfig } from "../../visa";
import {  Observable, of} from "rxjs";
import {
  debounceTime,
  distinctUntilChanged,
} from "rxjs/operators";
import { SubSink } from "subsink2";
import { UserPermInquirySelectors } from "../../modules/permission/user-permissions-inquiry-controller/selectors";
import { PermissionStates } from "../../modules/permission/permission-controller/root";

@Component({
  selector: "warehouse-advanced-search-drop-down",
  templateUrl: "./warehouse-advanced-search-drop-down.component.html",
  styleUrls: ["./warehouse-advanced-search-drop-down.component.css"],
})
export class WarehouseAdvancedSearchComponent implements OnInit, OnDestroy {
  @Input() warehouseControl = new FormControl();
  @Output() selectionChange = new EventEmitter();
  @Input() viewModelStore;
  @Input() ColumnViewActions;
  @Input() ColumnViewSelectors;
  @Input() readPermissionDefintion;

  userPermissionTarget$ = this.permissionStore.select(
    UserPermInquirySelectors.selectUserPermInquiry
  );

  private subs = new SubSink();
  separatorKeysCodes: number[] = [ENTER, COMMA];
  filteredWarehouses$: Observable<any[]>;
  warehouse: any[] = [];
  apiVisa: ApiVisa = AppConfig.apiVisa;
  allWarehouses:any

  @ViewChild("warehouseInput") warehouseInput: ElementRef<HTMLInputElement>;
  branchTargets: string[]=[];

  constructor(
    private readonly permissionStore: Store<PermissionStates>,
    private warehouseService: WarehouseService,

  ) {}

  ngOnInit(): void {
      this.subs.sink = this.warehouseService.get(this.apiVisa).subscribe((wmsResponse: any) => {
        const wmsListing = wmsResponse.data.map((data, index) => ({
          name: data.bl_wms_warehouse_hdr.title,
          guid: data.bl_wms_warehouse_hdr.guid,
          code: data.bl_wms_warehouse_hdr.code,
        }));
        this.allWarehouses = wmsListing;
        this.filteredWarehouses$ = of(this.allWarehouses);
        // console.log(this.allWarehouses)
      });
  

    this.warehouseControl.valueChanges
      .pipe(debounceTime(300), distinctUntilChanged())
      .subscribe((data) => this.filterTrips(data));


  }

  add(event: MatChipInputEvent): void {
    const value = (event.value || "").trim();
    if (value) {
      this.warehouse.push(value);
    }

    // Clear the input value
    event.input.value = "";

    this.warehouseControl.setValue(null);

    this.viewModelStore.dispatch(
      this.ColumnViewActions.setAdvanceSearch_WarehouseField({
        warehouse: this.warehouse,
      })
    );
  }

  remove(trip: any): void {
    const i = this.warehouse.findIndex(
      (value) => value.guid === trip.guid
    );
    this.warehouse[i].selected = false
    this.warehouse.splice(i, 1);
    this.viewModelStore.dispatch(
      this.ColumnViewActions.setAdvanceSearch_WarehouseField({
        warehouse: this.warehouse,
      })
    );
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    console.log(event.option);
    this.warehouse.push(event.option.value);
    this.warehouseInput.nativeElement.value = "";
    this.warehouseControl.setValue(null);
  }

  filterTrips(search: string)  {
    const searchResults = this.searchTrips(search);
    this.filteredWarehouses$ = of(searchResults);
  }


  searchTrips(searchTerm: string): any[] {
    if (searchTerm) {
      const lowerSearchTerm = searchTerm.toLowerCase();
      let output = [];
      this.allWarehouses.forEach((trip) => {
        if (
          trip.name.toLowerCase().includes(lowerSearchTerm) ||
          trip.code.toLowerCase().includes(lowerSearchTerm)
        ) {
          output.push(trip);
        }
      });
      console.log("output -->", output);
      return output;
    }
    return [];
  }

  optionClicked(event: Event, driver: any) {
    event.stopPropagation();
    this.toggleSelection(driver);
  }

  toggleSelection(trip: any) {
    console.log(trip);
    trip.selected = !trip.selected;
    this.warehouseInput.nativeElement.value = "";
    if (trip.selected) {
      this.warehouse.push(trip);
      this.viewModelStore.dispatch(
        this.ColumnViewActions.setAdvanceSearch_WarehouseField({
          warehouse: this.warehouse,
        })
      );
    } else {
      const i = this.warehouse.findIndex(
        (value) => value.guid === trip.guid
      );
      this.warehouse.splice(i, 1);
      this.viewModelStore.dispatch(
        this.ColumnViewActions.setAdvanceSearch_WarehouseField({
          warehouse: this.warehouse,
        })
      );
    }
  }

  onReset() {
    this.warehouse = []
    this.viewModelStore.dispatch(
      this.ColumnViewActions.setAdvanceSearch_WarehouseField({
        warehouse: [],
      })
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
